import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfirmDialogOptions } from '@app/core/models/confirm-dialogue.model';

@Component({
    selector: 'neo-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogOptions,
    private domSanitizer: DomSanitizer
  ) { }

  get subHeadingContent(): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(this.data.subHeading || '');
  }

}
